import React from 'react';
import PropTypes from 'prop-types';

import Search from '../search/Search.jsx';
import ReasonCodeList from 'Components/ReasonCode/reason-code-list/ReasonCodeList.jsx';
import OutsideClickHandler from 'Components/OutsideClickHandler';
import SearchIcon from 'Components/icons/SearchIcon';
import classnames from 'classnames';
import TextField from 'Components/forms/text-field/TextField';


import 'Components/forms/forms.styles.js';
import './ReasonCode.scss';

const ReasonCode = ({ title, onChange, updateIsIndeterminate, placeHolder, extraClass, searchTerm, dataList, visible, noBorder, onClick, handleOutsideClick, handleChange, handleHeaderCheckbox, toggleCollapse, selectedValue, removeFilterAction, showDynamicFilter, updatedId, name, listHeight, elementId, disabled, mreCustomHolder, reportName, isMreFilterPaneVisible }) => {
  const autocompleteClass = classnames(noBorder ? 'autocomplete_noborder' : 'code-view-autocomplete', {
    [extraClass]: extraClass,
  });

  const value = searchTerm;
  const lowercaseSearchTerm = value && value.toLowerCase && value.toLowerCase();

  let dataListFiltered = [];
   dataList !== undefined && dataList.map(obj =>{
     if(obj.key!=="null")
        dataListFiltered.push(obj);
  });

  const filteredUserstmp = dataListFiltered !== undefined && dataListFiltered.map(u => {
    u.items.map(c => {
      return Object.assign({}, c);
    })
    return Object.assign({}, u);
  })
  const filteredUsers = filteredUserstmp !== false && filteredUserstmp.filter((user) => {
    const filteredChildren = user.items.filter((child) => {
        return child.text.toLowerCase().includes(lowercaseSearchTerm);
    });
    user.items = filteredChildren;
    return (filteredChildren.length > 0);
  });

  updateIsIndeterminate(filteredUsers);
  let displayList = (value !== '' && value !== undefined ) ? filteredUsers : dataListFiltered;
  let totalSelectedItems = 0;
  displayList && displayList.forEach(element => {
    element.items.forEach(item => {
      item.selected && ++totalSelectedItems;
    })
  });
  if (value) {
    for (let i = 0; i < filteredUsers.length; i++) {
      filteredUsers[i].isExpanded = true;
    }
  }

  let newPlaceHolder = elementId == "cq_base_queue" ? placeHolder.customPlaceHolder : (totalSelectedItems > 0 ? `${totalSelectedItems} value(s) are selected` : placeHolder.placeHolder);
  if(elementId == "mre_reason_code") {
    newPlaceHolder = totalSelectedItems > 0 ? `${totalSelectedItems} value(s) are selected` : mreCustomHolder;
  }

  return (
    <div className="reason-code-wrapper">
      <TextField
        htmlFor={title}
        labelContent={title}
        removeFilterAction={removeFilterAction}
        showDynamicFilter={showDynamicFilter}
        updatedId={updatedId}
        callingComponent={elementId == "cq_base_queue" && "CreateCustomQueueLanding"}
      >
        <OutsideClickHandler
          onClickOutside={()=>handleOutsideClick(updatedId)}
        >
          <div className={autocompleteClass} >
            <div role='button' id={name} className="reason-code-srch-mngr" onClick={() => onClick(name)}>
              <div className="reason-code-srch-icon"> <SearchIcon /> </div>
              <Search
                filterText={searchTerm}
                onChange={onChange}
                placeholder={newPlaceHolder}
                filtername={name}
                style={{ width: "200px" }}
                isMreFilterPaneVisible={isMreFilterPaneVisible}
                reportName={reportName}
              />
            </div>
            <ReasonCodeList
              dataList={displayList}
              handleHeaderCheckbox={handleHeaderCheckbox}
              visible={visible}
              searchTerm={searchTerm}
              extraClass=''
              handleChange={handleChange}
              toggleCollapse={toggleCollapse}
              handleOutsideClick={handleOutsideClick}
              updateIsIndeterminate={updateIsIndeterminate}
              filterName={name}
              listHeight={listHeight}
              elementId={elementId}
              disabled = {disabled}
              isMreFilterPaneVisible={isMreFilterPaneVisible}
            />
          </div>
        </OutsideClickHandler>
      </TextField>
    </div>
  );
};

ReasonCode.propTypes = {
  name: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  onBlur: PropTypes.func,
  isRequired: PropTypes.bool,
  disable: PropTypes.bool,
  hideLabel: PropTypes.bool,
  isWidthFixRequired: PropTypes.bool,
  removeFilterAction: PropTypes.func,
  showDynamicFilter: PropTypes.bool,
  updatedId: PropTypes.string,
  disabled: PropTypes.bool,
  mreCustomHolder: PropTypes.string,
  reportName: PropTypes.string,
};

ReasonCode.defaultProps = {
  type: 'text',
  placeholder: '',
  error: '',
  onBlur: null,
  isRequired: false,
  labelTooltip: null,
  hideErrorIcon: true,
  disable: false,
  hideLabel: false,
  isWidthFixRequired: false,
  removeFilterAction: () => { },
  showDynamicFilter: false,
  updatedId: '',
  disabled: false,
  mreCustomHolder: '',
  reportName: '',
};

export default ReasonCode;
